import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { errorTypes } from "@/utility/validation"
import { Button } from "@/components/ui/button"
import Card from "@/components/common/Card"
import { ThrowError } from "@/api/callApi"
import { RoutesLink } from "@/utility/RouteLinks"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import Layout from "@/components/layout/Layout"
import MainHeading from "@/components/common/MainHeading"
import FormField from "@/components/common/FormField"
import { showToastNotification } from "@/utility/helper"
import type { campus } from "@/interface/campus.interface"
import { CampusService } from "@/services/Campus/CampusService"
import { SiteService } from "@/services/Site/SiteServive"
import SearchSelect from "@/components/common/SearchSelect"
import FullPageLoader from "@/components/common/FullPageLoader"
// import FullPageLoader from "@/components/common/FullPageLoader"
import states from "@/utility/states.json"

const fetchPincodeDetails = async (pin: string) => {
    if (!pin || pin.length !== 6 || !/^\d{6}$/.test(pin)) return null;
    try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
        const data = await response.json();
        if (Array.isArray(data) && data[0]?.Status === 'Success' && data[0]?.PostOffice?.length > 0) {
            const postOffice = data[0].PostOffice[0];
            return {
                district: postOffice.District,
                state: postOffice.State,
            };
        }
    } catch (e) {
        console.error("Error fetching pincode details:", e);
    }
    return null;
};

const AddCampus: React.FC = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [isFatchLoading, setIsFatchLoading] = useState(false)
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm<campus>({
        mode: "onChange",
    });
    const [sites, setSites] = useState<{ value: string; label: string }[]>([]);

    const pinCode = watch("pinCode");

    useEffect(() => {
        if (pinCode && pinCode.length === 6 && /^\d{6}$/.test(pinCode)) {
            const getDetails = async () => {
                const details = await fetchPincodeDetails(pinCode);
                if (details) {
                    if (details.state) {
                        setValue("state", details.state, { shouldValidate: true, shouldDirty: true });
                    }
                    if (details.district) {
                        setValue("city", details.district, { shouldValidate: true, shouldDirty: true });
                    }
                }
            };
            getDetails();
        }
    }, [pinCode, setValue]);
    // const [menuBars, setMenuBar] = useState<{ value: string; label: string }[]>([]);

    const getSite = async () => {
        try {
            setIsFatchLoading(true);
            const response = await SiteService.getSite();
            if (response?.status) {
                const formatted = (response?.data?.site || []).map((item) => ({
                    value: item?.id || "",
                    label: item?.name || ""
                }));
                setSites(formatted);
            }
        } catch (error) {
            ThrowError(error);
        } finally {
            setIsFatchLoading(false)
        }
    }

    const getCampusById = async () => {
        if (!id) return;
        setIsFatchLoading(true);
        try {
            const response = await CampusService.getCampusById(id);
            if (response?.status) {
                setValue("name", response?.data?.name);
                setValue("siteId", response?.data?.siteId);
                setValue("address", response?.data?.address);
                setValue("city", response?.data?.city);
                setValue("state", response?.data?.state);
                setValue("pinCode", response?.data?.pinCode);
                setValue("status", response?.data?.status);
                setValue("code", response?.data?.code);
            }
        } catch (error) {
            ThrowError(error);
        } finally {
            setIsFatchLoading(false);
        }
    }

    useEffect(() => {
        getSite();
        if (id) {
            getCampusById();
        }
    }, []);

    const onSubmit = async (data: campus) => {
        try {
            setIsLoading(true);
            const payload = {
                name: data.name,
                siteId: data.siteId,
                address: data.address,
                city: data.city,
                state: data.state,
                pinCode: data.pinCode,
                status: data.status,
                code: data.code,

            }
            if (id) {
                const response = await CampusService.updateCampus(id, payload);
                if (response?.status) {
                    showToastNotification("success", response?.message);
                    navigate(RoutesLink.superAdminCampus);
                }
            } else {
                const response = await CampusService.createCampus(payload);
                if (response?.status) {
                    showToastNotification("success", response?.message);
                    navigate(RoutesLink.superAdminCampus);
                }
            }
        } catch (error) {
            ThrowError(error);
        } finally {
            setIsLoading(false);
        }
    }

    if (isFatchLoading) {
        return (
            <Layout>
                {/* <div className="flex items-center justify-center min-h-[400px]"> */}
                <FullPageLoader />
                {/* <Spinner className="h-8 w-8 text-primary animate-spin" /> */}
                {/* </div> */}
            </Layout >
        );
    }

    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading
                    title={id ? "Edit Campus" : "Add Campus"}
                    isBackButtonVisible
                    onClick={() => navigate(-1)}
                />
                <Card className='overflow-visible'>
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormField
                                {...register("name", { ...errorTypes.required('Name'), ...errorTypes.name })}
                                type="text"
                                label="Name"
                                maxLength={30}
                                placeholder="Enter Designation Name"
                                error={errors.name?.message}
                                required
                            />
                            <SearchSelect
                                label="Site"
                                required
                                placeholder="Select Site"
                                options={sites}
                                value={watch("siteId")}
                                onChange={(val) => setValue("siteId", val)}
                                error={errors.siteId?.message}

                            />
                            {/* <FormField
                                {...register("isParent", { ...errorTypes.required("Is Parent") })}
                                type="text"
                                label="Is Parent"
                            // error={errors.isParent?.message}
                            /> */}
                            {/* <MultiSelectSearch
                                label="Menu Access"
                                required
                                placeholder="Select Menu Access"
                                options={menuBars}
                                value={watch("menuBar")?.keyNames || []}
                                onChange={(val) => setValue("menuBar", { keyNames: val })}
                                error={errors.menuBar?.message}

                            /> */}
                            <FormField
                                {...register("address", { ...errorTypes.required("Address"), ...errorTypes.address })}
                                type="text"
                                label="Address"
                                maxLength={100}
                                placeholder="Enter Address"
                                error={errors.address?.message}
                                required
                            />
                            <FormField
                                {...register("pinCode", { ...errorTypes.required("Pin Code"), ...errorTypes.pinCode })}
                                type="text"
                                label="Pin Code (Auto Fetch State & City)"
                                maxLength={6}
                                minLength={6}
                                placeholder="Enter Pin Code"
                                error={errors.pinCode?.message}
                                required
                            />

                            <FormField
                                {...register("state", { ...errorTypes.required('State') })}
                                type="select"
                                name="state"
                                label="State"
                                placeholder="Select State"
                                options={states}
                                value={watch("state") || ""}
                                error={errors.state?.message}
                                required
                            />

                            <FormField
                                {...register("city", { ...errorTypes.required("City"), ...errorTypes.city })}
                                type="text"
                                label="City"
                                placeholder="Enter City"
                                error={errors.city?.message}
                                required
                            />

                            <FormField
                                {...register("status", { ...errorTypes.required("Status") })}
                                type="select"
                                value={String(watch("status") ?? "")}
                                options={[
                                    { value: "select", label: "Select Status" },
                                    { value: "true", label: "Active" },
                                    { value: "false", label: "Inactive" },
                                ]}
                                label="Is Active"
                                error={errors.status?.message}
                                required
                            />

                        </div>
                        <div className="flex justify-end">
                            <Button disabled={isLoading} type="submit">{isLoading ? "Submitting..." : "Submit"}</Button>
                        </div>
                    </form>
                </Card>
            </div>
        </Layout>
    )
}

export default AddCampus